import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import Routes from './Routes'
import { ConfigProvider } from "antd";
import React, { Component } from "react";
import './antd.css'; 
import "./scss/pages/app.scss"
import { connect } from "react-redux"; 
import { QueryClient, QueryClientProvider, useQuery } from 'react-query'
import { setCurrentLang } from "./redux/user/user.action";
const queryClient = new QueryClient()
class App extends Component {

  componentDidMount() {
    if(localStorage.getItem("lang") === null){ 
      localStorage.setItem("lang", "en")
      document.getElementsByTagName("html")[0].setAttribute("lang", "en");  
      this.props.dispatch(setCurrentLang("en")); 
    }else{ 
      document.getElementsByTagName("html")[0].setAttribute("lang", this.props.currentLang); 
    }
    var uniq = Date.now().toString(36) + Math.random().toString(36).substr(2); 
    if(localStorage.getItem("deviceId") === null){
      localStorage.setItem("deviceId", uniq)
    } 
  }

  render() { 
    const {currentLang} = this.props;
    return (
      <QueryClientProvider client={queryClient}>
      <div className="app-wrapper">
        <ConfigProvider direction={currentLang === "en" ? "ltr" : "rtl"}> 
          <Router>
            <Switch>
              <Routes /> 
              
            </Switch>
          </Router>
        </ConfigProvider>
      </div>
      </QueryClientProvider>
    );
  }
}


const mapStateToProps = (state) => ({
  currentLang : state.user.currentLang
}) 

export default  connect(mapStateToProps)(App);
